import React, { useState, useEffect, useContext } from "react";
import { Label, Form, FormGroup, Row, Col, Input, InputGroup } from "reactstrap";
import Select from "react-select";
import DatePicker from "react-datepicker";
import { useController, useForm } from "react-hook-form";
import { formatDateTime, getCarTypes, getCorporateClientsBySeviceCityIdAndTravelType, getUserDetails, showAlert } from "../../Services/Shared.service";
import {  getAuthoritiesList,  getPartnersList } from "../../Services/Employee.service";
import { ArrowDown, ArrowUp } from "react-feather";
import { CommonModal } from "../../AbstractElements";
import CustomSelect from "../../CommonElements/CustomSelect";
import CustomizerContext from "../../_helper/Customizer";
import AsyncSelect from 'react-select/async';
import { createExternalUserList, getExternalUserById, updateExternalUser } from "../../Services/ExternalUser.service";
import { getExternalThirdPartyListBySearch } from "../../Services/ExternalThirdParty.service";

const ExternalUserInput = ({ Large, title, LargeModaltoggle, cityData, editId, fetchTableData }) => {
    const {
        register,
        control,
        handleSubmit,
        formState: { errors },
        setValue,
        getValues,
        reset,
        watch
    } = useForm({
        defaultValues: {
            fullName: "",
            sapId: "",
            ipAddress: "",
            extension: "",
            email: "",
            mobile: "",
            thirdPartyClient:"",
            authoritiesDropdown: [],
            partnerApiIdDropdown: {},
            serviceCityDropdown: [],
            activated: false
        },
    });
    const values = getValues()
    const [authoritiesData, setAutoritiesData] = useState([])
    const [partnerList, setPartnerList] = useState([])
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [isAdvanced, setIsAdvanced] = useState(false)
    const [employeeDetails, setEmployeeDetails] = useState({})
    
  const [selectedOption, setSelectedOption] = useState();

  console.log("selectedOption",selectedOption)
    const {mix_background_layout} = useContext(CustomizerContext)

    const isActivatedField = useController({
        name: "activated",
        control,
        rules: {},
    }).field;

    const serviceCityField = useController({
        name: "serviceCityDropdown",
        control,
        rules: {
            required: {
                value: true,
                message: "Service City is Required",
            },
        },
    }).field;

    // const authoritiesField = useController({
    //     name: "authoritiesDropdown",
    //     control,
    //     rules: {
    //         required: {
    //             value: true,
    //             message: "Authorities is Required",
    //         },
    //     },
    // }).field;

    const partnerApiIdField = useController({
        name: "partnerApiIdDropdown",
        control,
        rules: {
            required: {
                value: true,
                message: "Authorities is Required",
            },
        },
    }).field;
    const thirdPartyClientField = useController({
      name: "thirdPartyClient",
      control,
      rules: {
          required: {
              value: true,
              message: "Third Party is Required",
          },
      },
  }).field;

    const handleServiceCitySelectChange = (data) => {
        console.log("data", data)
        serviceCityField.onChange(data.map(d => d.value));
    };

    // const handleAuthoritiesSelectChange = (data) => {
    //     console.log("data", data)
    //     authoritiesField.onChange(data.map(d => d.value));
    // };

    const handlePartnerApiIdSelectChange = (data) => {
        partnerApiIdField.onChange(data.value);
    };

    const mobileField = useController({
        name: "mobile",
        control,
        rules: {
            required: {
                value: true,
                message: "Mobile Number is Required",
            },
            minLength: {
                value: 10,
                message: "Mobile Number cannot be less than 10",
            },
            maxLength: {
                value: 10,
                message: "Mobile Number cannot be more than 10",
            },
            min: {
                value: 0,
                message: "Invalid Mobile Number",
            },
            maxLength: 10
        },
    }).field;

    useEffect(() => {
        getAuthoritiesList().then((result) => {
            if (result.status == 200) {
                const data = result.data.map((element) => {
                    return {
                        value: element,
                        label: element.name,
                    };
                });
                setAutoritiesData(data);
            }
        });
        // unwanted
        getPartnersList().then((result) => {
            if (result.status == 200) {
                const data = result.data.map((element) => {
                    return {
                        value: element,
                        label: element.value,
                    };
                });
                setPartnerList(data);
            }
        });
    }, [])

    useEffect(() => {
        if (editId) {
            getExternalUserById(editId)
                .then((result) => {
                    if (result.data) {
                        setEmployeeDetails(result.data)
                        let authorities = result.data.authorities ? [... new Set(result.data.authorities.split(","))] : []
                        let uniqueServiceCities = result.data.serviceCities ? [... new Set(result.data.serviceCities.split(","))] : []
                        let serviceCities = uniqueServiceCities.map((city, index) => {
                            let findIndex = cityData.findIndex((c) => c.id == Number(city))
                            if (findIndex >= 0) {
                                return cityData[findIndex]["value"]
                            }
                        }).filter((c) => c != undefined || null || "")
                        reset({
                            fullName: result.data.fullName ? result.data.fullName : "",
                            sapId: result.data.sapId ? result.data.sapId : "",
                            ipAddress: result.data.ipAddress ? result.data.ipAddress : "",
                            extension: result.data.extension ? result.data.extension : "",
                            email: result.data.email ? result.data.email : "",
                            mobile: result.data.mobile ? result.data.mobile : "",
                            authoritiesDropdown: authorities.length > 0 ? authorities.map((a) => {
                                return { name: a }
                            }) : [],
                            partnerApiIdDropdown: result.data.partnerApiId ? { id: result.data.partnerApiId } : {},
                            serviceCityDropdown: serviceCities.length > 0 ? serviceCities : [],
                            activated: result.data.activated ? true : false,
                            thirdPartyClient:thirdPartyHelper(result.data),
                            thirdPartyClientName: result?.data?.thirdPartyClientName ?result?.data?.thirdPartyClientName:""
                        })
                    }
                })
                .catch((err) => {
                    LargeModaltoggle()
                    showAlert("error", err.response?.data?.message ? err.response.data.message : "Something went wrong");
                });
        }
    }, [editId])
    const watcSh=watch()
    console.log(watcSh,"VYSHHS")

    const thirdPartyHelper=(data)=>{
      console.log(data)
      return{
        value:data?.thirdPartyClientId?data.thirdPartyClientId:"",
        label:data?.thirdPartyClientName?data?.thirdPartyClientName:""
      }

    }

    const onFormSubmit = (formValues) => {
        setIsSubmitting(true)
        const body = {
            fullName: formValues.fullName ? formValues.fullName : null,
            sapId: formValues.sapId ? formValues.sapId : null,
            ipAddress: formValues.ipAddress ? formValues.ipAddress : null,
            extension: formValues.extension ? formValues.extension : null,
            email: formValues.email ? formValues.email : null,
            mobile: formValues.mobile ? formValues.mobile : null,
            authorities:["ROLE_EXTERNAL_BOOKING_AGENT"],
            thirdPartyClientId:formValues.thirdPartyClient?formValues.thirdPartyClient?.value:"",
            // formValues.authoritiesDropdown.map((a) => a.name),
            // partnerApiId: formValues.partnerApiIdDropdown?.id ? formValues.partnerApiIdDropdown?.id : null,
            serviceCityId: formValues.serviceCityDropdown.map((a) => a.id),
        }
        if (editId) {
            let authorities = employeeDetails.authorities ? [... new Set(employeeDetails.authorities.split(","))] : []

            let authoritiesRemoved = authorities.filter((a) => {
                return !formValues.authoritiesDropdown.some(el => el.name === a);
            })
            let uniqueServiceCities = employeeDetails.serviceCities ? [... new Set(employeeDetails.serviceCities.split(","))] : []
            let serviceCitiesRemoved = uniqueServiceCities.filter((a) => {
                return !formValues.serviceCityDropdown.some(el => el.id === Number(a));
            }).map((c) => Number(c))
            body["id"] = Number(editId)
            body["userId"] = Number(employeeDetails.userId)
            body["createdOn"] = employeeDetails.createdOn ? new Date(employeeDetails.createdOn) : null
            body["createdById"] = employeeDetails.createdById ? Number(employeeDetails.createdById) : null
            body["deletedOn"] = employeeDetails.deletedOn ? new Date(employeeDetails.deletedOn) : null
            body["deletedById"] = employeeDetails.deletedById ? Number(employeeDetails.deletedById) : null
            body["removeAuthorities"] = authoritiesRemoved
            body["removeServiceCityIdList"] = serviceCitiesRemoved
            body["activated"] = formValues.activated ? true : false
            body["thirdPartyClientName"] =formValues?.thirdPartyClientName?formValues?.thirdPartyClientName:""
            updateExternalUser(body)
                .then((result) => {
                    reset({
                        fullName: "",
                        sapId: "",
                        ipAddress: "",
                        extension: "",
                        email: "",
                        mobile: "",
                        thirdPartyClient:"",
                        authoritiesDropdown: [],
                        partnerApiIdDropdown: {},
                        serviceCityDropdown: [],
                        activated: false
                    })
                    showAlert("success", "External User Updated Successfully");
                    fetchTableData();
                    setIsSubmitting(false)
                    LargeModaltoggle();
                })
                .catch((err) => {
                    showAlert("error", err.response?.data?.message
                        ? err.response.data.message : "Something went wrong");
                    setIsSubmitting(false)
                });
        } else {
            createExternalUserList(body)
                .then((result) => {
                    reset({
                        fullName: "",
                        sapId: "",
                        ipAddress: "",
                        extension: "",
                        email: "",
                        mobile: "",
                        authoritiesDropdown: [],
                        partnerApiIdDropdown: {},
                        serviceCityDropdown: [],
                        activated: false
                    })
                    showAlert("success", "External User Created Successfully");
                    fetchTableData();
                    setIsSubmitting(false)
                    LargeModaltoggle();
                })
                .catch((err) => {
                    showAlert("error", err.response?.data?.message
                        ? err.response.data.message : "Something went wrong");
                    setIsSubmitting(false)
                });
        }
    };

    console.log("service city values", serviceCityField.value)

    const getCorporateClient = async (inputValue) => {
        if (inputValue.length) {
          console.log(inputValue);
    
          const serviceCityId = 0;
          let obj = {
            serviceCityId: serviceCityId,
            name: inputValue,
          };
          return getExternalThirdPartyListBySearch(obj).then((result) => {
            // Map the array of objects returned by getCorporateClientsListBySearch
            
            const mappedArray = result.data.list.map((item) => ({
              value: item.id,
              label: item.companyName,
            }));
           
            return mappedArray;
          });
        }
      };
      const handleSelectOption = corporate =>{
        setValue("thirdPartyClient",corporate);
      }

    return (
        <CommonModal
            isOpen={Large}
            title={title}
            toggler={() => {
                reset({
                    fullName: "",
                    sapId: "",
                    ipAddress: "",
                    thirdPartyClient:"",
                    extension: "",
                    email: "",
                    mobile: "",
                    authoritiesDropdown: [],
                    partnerApiIdDropdown: {},
                    serviceCityDropdown: [],
                    activated: false
                })
                LargeModaltoggle()
            }}
            size="xl"
        >
            <Form onSubmit={handleSubmit(onFormSubmit)}>
                <Row>
                    <FormGroup className="col-lg-3">
                        <Label className="col-lg-12 col-form-label">Email</Label>
                        <Col lg="12">
                            <input
                                className="form-control"
                                type="text"
                                {...register("email", {
                                    onChange: (e) => {
                                        setValue("email", e.target.value.trimStart())
                                    },
                                    required: {
                                        value: true,
                                        message: "Email is required",
                                    },
                                    pattern: {
                                        value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                                        message: "Please enter a valid email !",
                                    },
                                })}
                            />
                            <span style={{ color: "red" }}>{errors?.email?.message}</span>
                        </Col>
                    </FormGroup>
                    <FormGroup className="col-lg-3">
                        <Label className="col-lg-12 col-form-label">Full Name</Label>
                        <Col lg="12">
                            <input
                                className="form-control"
                                type="text"
                                {...register("fullName", {
                                    required: {
                                        value: true,
                                        message: "Full Name is Required",
                                    },
                                    onChange: (e) => {
                                        setValue("fullName", e.target.value.trimStart())
                                    }
                                })}
                            />
                            <span style={{ color: "red" }}>{errors?.fullName?.message}</span>
                        </Col>
                    </FormGroup>
                    <FormGroup className="col-lg-3">
                        <Label className="col-lg-12 col-form-label">Mobile</Label>
                        <Col lg="12">
                            <input
                                type="text"
                                className="form-control"
                                maxLength={10}
                                value={mobileField.value}
                                pattern="[0-9]+"
                                onChange={(e) => {
                                    mobileField.onChange(e.target.value.replace(/[^0-9]/g, ''))
                                }}
                            />
                            <span style={{ color: "red" }}>{errors?.mobile?.message}</span>
                        </Col>
                    </FormGroup>
                    {/* <FormGroup className="col-lg-3">
                        <Label className="col-lg-12 col-form-label">Authorities</Label>
                        <Col lg="12">
                            <div className="city-select">
                                <CustomSelect
                                    isMulti
                                    className="service-select"
                                    classNamePrefix="select"
                                    isClearable={false}
                                    isSearchable={false}
                                    value={authoritiesField?.value ? authoritiesField.value.map((s) => {
                                        return {
                                            label: s.name,
                                            value: s
                                        }
                                    }) : []}
                                    // isDisabled={corporateClientObj?.id ? true : false}
                                    // defaultValue={cityData.find((element) => {
                                    //   console.log(cityField?.value?.id,element?.value?.id,'element?.value?.idelement?.value?.id');
                                    //   return element?.value?.id === cityField?.value?.id;
                                    // })}
                                    onChange={handleAuthoritiesSelectChange}
                                    placeholder="Select Authorities"
                                    options={authoritiesData}
                                />
                            </div>
                            <span style={{ color: "red" }}>{errors?.authoritiesDropdown?.message}</span>
                        </Col>
                    </FormGroup> */}

                    <FormGroup className="col-lg-3">
                        <Label className="col-lg-12 col-form-label">Service City</Label>
                        <Col lg="12">
                            <div className="city-select">
                                <CustomSelect
                                    isMulti
                                    className="service-select"
                                    classNamePrefix="select"
                                    isClearable={false}
                                    isSearchable={false}
                                    value={serviceCityField?.value ? serviceCityField.value.map((s) => {
                                        return {
                                            label: s.name,
                                            value: s
                                        }
                                    }) : []}
                                    // isDisabled={corporateClientObj?.id ? true : false}
                                    // defaultValue={cityData.find((element) => {
                                    //   console.log(cityField?.value?.id,element?.value?.id,'element?.value?.idelement?.value?.id');
                                    //   return element?.value?.id === cityField?.value?.id;
                                    // })}
                                    onChange={handleServiceCitySelectChange}
                                    placeholder="Select City"
                                    options={cityData}
                                />
                            </div>
                            <span style={{ color: "red" }}>{errors?.serviceCityDropdown?.message}</span>
                        </Col>
                    </FormGroup>
                    <FormGroup className="col-lg-3">
                <Label className="col-lg-12 col-form-label">
                  Third Party Client
                </Label>
                <Col lg="12">
                  <AsyncSelect
                    cacheOptions
                    loadOptions={getCorporateClient}
                    value={getValues("thirdPartyClient")}
                    onChange={handleSelectOption}
                    // isDisabled={true}
                    placeholder={"Existing Third party client"}
                  />
                  <span style={{ color: "red" }}>
                    {errors?.thirdPartyClient?.message}
                  </span>
                </Col>
              </FormGroup>
                    {editId ? <FormGroup className="col-lg-3" style={{ display: "flex", alignItems: "center" }}>
                        <div style={{ display: "flex", alignItems: "center" }} className={mix_background_layout == "dark-only" ? "checkbox-dark p-0" : "checkbox p-0"}>
                            <Input id="isAvailable" type="checkbox" checked={isActivatedField.value}
                                onChange={(value) => isActivatedField.onChange(value)} />
                            <Label className="mb-0" for="isAvailable">Is Activated</Label>
                        </div>
                    </FormGroup> : null}
                </Row>
                <Row>
                    <div style={{ color: "#11BF5C", textDecoration: "underline", display: "flex", alignItems: "center", cursor: "pointer" }} onClick={() => setIsAdvanced(!isAdvanced)}>Advanced Configurations {isAdvanced ? <ArrowUp style={{ width: "15px", height: "15px", marginLeft: "5px" }} /> : <ArrowDown style={{ width: "15px", height: "15px", marginLeft: "5px" }} />}</div>
                </Row>
                {isAdvanced ? (
                    <Row>
                        <FormGroup className="col-lg-3">
                            <Label className="col-lg-12 col-form-label">Sap Id</Label>
                            <Col lg="12">
                                <input
                                    className="form-control"
                                    type="text"
                                    {...register("sapId", {
                                        onChange: (e) => {
                                            setValue("sapId", e.target.value.trimStart())
                                        }
                                    })}
                                />
                                <span style={{ color: "red" }}>{errors?.sapId?.message}</span>
                            </Col>
                        </FormGroup>
                        <FormGroup className="col-lg-3">
                            <Label className="col-lg-12 col-form-label">Ip Address</Label>
                            <Col lg="12">
                                <input
                                    className="form-control"
                                    type="text"
                                    {...register("ipAddress", {
                                        onChange: (e) => {
                                            setValue("ipAddress", e.target.value.trimStart())
                                        }
                                    })}
                                />
                                <span style={{ color: "red" }}>{errors?.ipAddress?.message}</span>
                            </Col>
                        </FormGroup>
                        <FormGroup className="col-lg-3">
                            <Label className="col-lg-12 col-form-label">Extension</Label>
                            <Col lg="12">
                                <input
                                    className="form-control"
                                    type="text"
                                    {...register("extension", {
                                        onChange: (e) => {
                                            setValue("extension", e.target.value.trimStart())
                                        }
                                    })}
                                />
                                <span style={{ color: "red" }}>{errors?.extension?.message}</span>
                            </Col>
                        </FormGroup>
                        {/* {authoritiesField?.value?.length > 0 ? <FormGroup className="col-lg-3">
                            <Label className="col-lg-12 col-form-label">Partner Api</Label>
                            <Col lg="12">
                                <div className="city-select">
                                    <CustomSelect
                                        className="service-select"
                                        classNamePrefix="select"
                                        isClearable={false}
                                        isSearchable={false}
                                        value={partnerApiIdField?.value?.id ? partnerList.find((element) => {
                                            return element?.value?.id === partnerApiIdField?.value?.id;
                                        }) : ""}
                                        // isDisabled={corporateClientObj?.id ? true : false}
                                        // defaultValue={cityData.find((element) => {
                                        //   console.log(cityField?.value?.id,element?.value?.id,'element?.value?.idelement?.value?.id');
                                        //   return element?.value?.id === cityField?.value?.id;
                                        // })}
                                        onChange={handlePartnerApiIdSelectChange}
                                        placeholder="Select partner api"
                                        options={partnerList}
                                    />
                                </div>
                                <span style={{ color: "red" }}>{errors?.authoritiesDropdown?.message}</span>
                            </Col>
                        </FormGroup> : null} */}
                    </Row>
                ) : null}


                <div style={{ display: "flex", justifyContent: "center" }}>
                    <button type="submit" className="btn submit-button" disabled={isSubmitting}>
                        {editId ? "Update" : "Create"}
                    </button>
                </div>
            </Form>
        </CommonModal>
    )
}

export default ExternalUserInput